<template>
  <figure class="max-diagram max-panel" :aria-label="node.title || undefined">
    <figcaption v-if="node.title" class="max-panel__title">{{ node.title }}</figcaption>
    <!-- svg is Mermaid output (securityLevel strict) re-sanitised with DOMPurify's SVG profile -->
    <div v-if="svg" class="max-diagram__canvas" role="img" :aria-label="node.caption || node.title || sanitized.type" v-html="svg" />
    <div v-else-if="!error" class="max-chart__skeleton" style="height: 160px" role="status" :aria-label="ctx.labels.loadingChart" />
    <p v-if="error" class="max-callout" data-intent="warning">{{ ctx.labels.diagramFailed }}</p>
    <p v-if="node.caption" class="max-chart__caption">{{ node.caption }}</p>
  </figure>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, useId, watch } from 'vue'
import { DIAGRAM_PURIFY, mermaidConfig, sanitizeMermaid } from '../core/diagram.ts'
import { useMaxContext } from '../runtime/context.ts'

const props = defineProps<{ node: any }>()
const ctx = useMaxContext()
const svg = ref('')
const error = ref(false)
const renderId = 'max-diagram-' + useId().replace(/[^a-z0-9-]/gi, '')

const sanitized = computed(() => sanitizeMermaid(props.node.source))

let mermaidPromise: Promise<any> | null = null
let purifyPromise: Promise<any> | null = null

async function render () {
  if (!sanitized.value.ok) {
    error.value = true
    return
  }
  try {
    mermaidPromise ??= import('mermaid').then(m => m.default)
    purifyPromise ??= import('dompurify').then(m => m.default)
    const [mermaid, DOMPurify] = await Promise.all([mermaidPromise, purifyPromise])
    mermaid.initialize(mermaidConfig(ctx.preset))
    const { svg: out } = await mermaid.render(renderId, sanitized.value.source)
    svg.value = DOMPurify.sanitize(out, DIAGRAM_PURIFY)
    error.value = false
  } catch (e) {
    console.error('[johku-max] diagram render failed', e)
    error.value = true
  }
}

onMounted(render)
watch(sanitized, render)
</script>
